import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ContentBlock } from '../../pages/components/';
import BaseFormContainer from '../../common/components/form/BaseFormContainer';

import * as channelActions from '../channel.actions';
import CreateChannelForm from './CreateChannelForm';

import { Localize } from '../../../locale/localization';

const constraints = {
  name: {
    presence: {
      message: `^${Localize('form.create-channel.channel.error')}`
    },
  },
  email: {
    email: {
      message: `^${Localize('form.create-channel.email.error')}`
    }
  },
};

class CreateChannelFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      name: '',
      email: '',
    };

    this.state = {
      ...this.state,
      formData,
    };
  }

  getConstraints = () => constraints;

  doSubmit = (formData) => {
    const { createChannel, cancelPath, history } = this.props;
    createChannel(formData).then((action) => {
      if(action && action.response && action.response.status === 'ok') {
        history.replace(cancelPath);
      } else {
        let key = 'form.create-channel.error';
        if(action.error && action.error.status) {
          switch(action.error.status) {
            case 'user already exists':
              key += '.user';
              break;
            default:;
          }
        }
        this.setState({
          isSubmitting: false,
          submitFailed: true,
          submitted: true,
          formError: Localize(key),
        });
        /*
        this.setState({
          isSubmitting: false,
          submitFailed: true,
          submitted: true,
          formError: `${Localize('form.create-channel.error')}`,
        });
        */
      }
    });
  }

  onCancel = (event) => {
    event.preventDefault();
    
    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  }

  render() {
    return (
      <ContentBlock title={Localize('admin.add.channel')}>
        <CreateChannelForm
          enabled={!this.state.isSubmitting}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          onInputChange={this.onInputChange}
          onBlur={this.onBlur}
          errors={this.state.errors}
          touchedFields={this.state.touchedFields}
          isValid={this.state.isValid}
          name={this.state.formData.name}
          email={this.state.formData.email}
          formError={this.state.formError}
        />
      </ContentBlock>
    );
  }
}

const mapStateToProps = (state) => {
  return {

  };
};

const ConnectedCreateChannelFormContainer = connect(
  mapStateToProps,
  channelActions,
)(CreateChannelFormContainer);

export default withRouter(ConnectedCreateChannelFormContainer);


// WEBPACK FOOTER //
// ./src/modules/channel/components/CreateChannelFormContainer.js